import React, {Component} from 'react';
import '../Order/ViewSingleCustomerOrder/ViewSingleCustomerOrder.css';

import {FormattedMessage} from "react-intl";
import CustomerOrderItemTable from "../Order/CustomerOrderItemTable/CustomerOrderItemTable";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";
import NumberFormatter from "../../Common/NumberFormatter/NumberFormatter";
import {Link} from "react-router-dom";
import CustomerItemTableHeader from "../Order/CustomerItemTableHeader/CustomerItemTableHeader";
import CustomerItemTableRow from "../Order/CustomerItemTableRow/CustomerItemTableRow";
import ProductionItemTableRow from "./ProductionItemTableRow";

class ViewSingleItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData: [],
            orderItems: [],
            userInfo: [],
            orderId: this.props.match.params.id,
            billOrderInfo: [],
            shipOrderInfo: [],
            billContact:[],
            shipContact:[],
            userContact:[],
            total : '',
            subTotal : '',
            item:this.props.location.state.items,
            createdDate: '',
            deliveryDate: '',
            contactNumber : ''
        };
        this.getItemPrice = this.getItemPrice.bind(this);
        this.getUserData = this.getUserData.bind(this);
        this.getOrder = this.getOrder.bind(this);
    }

    componentDidMount() {
        console.log(this.props.location.state.items);
        this.getUserData();
        this.getOrder();
        this.getItemPrice();
    }

    getUserData = () => {
        axios.get(RESOURCE_BASE_URL + 'api/userdata/' + this.props.match.params.id)
            .then((res) => {
                this.setState({
                    userInfo:res.data,
                    contactNumber: res.data.contactNumber.number
                    // userContact:res.data.contactNumber
                });
                // console.log("userInfo---",res.data);

            })
            // .then(this.getItemPrice)
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getOrder = () => {

        axios.get(RESOURCE_BASE_URL + 'api/orders/' + this.props.match.params.id)
            .then((res) => {
                this.setState({
                    orderData: res.data,
                    createdDate:res.data.createdDate,
                    deliveryDate: res.data.deliveryDate,
                    billOrderInfo: res.data.orderBillingAddress,
                    shipOrderInfo: res.data.orderShippingAddress,
                    shipContact: res.data.orderShippingAddress.contactNumber,
                    billContact: res.data.orderBillingAddress.contactNumber
                });
                // console.log("order data",res.data);

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getItemPrice = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        // let postData = this.state.item;
        // console.log(postData)
        axios.get(RESOURCE_BASE_URL + 'api/orders/order/' + this.state.orderId,axiosConfig)
            .then((res) => {
                console.log(res.data);
                this.setState({
                    total : res.data.orderSummary.orderTotal,
                    subTotal : (res.data.orderSummary.orderTotal - res.data.orderSummary.taxAmount)
                });
                console.log(this.state.price);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    render() {
        // console.log("item2 contact",this.state.userInfo.contactNumber);

        return (
            <div className="admin-view-single-order-content">
                <div className="admin-view-single-order-div">
                    <div className="title-1">
                        <FormattedMessage id="app.admin.order.view.single.title"
                                          defaultMessage="ORDER "
                                          description=""/>&nbsp;
                        <span>{this.state.orderData.orderBatchNumber}</span>
                        <hr className="no-padding"/>
                    </div>

                    <div className="row">
                        <div className="row">
                            <div className="col-md-4">
                                <div className=" view-details-header-div">
                                <label className="admin-admin-view-single-order-label">
                                    <FormattedMessage id="app.admin.view.single.customer.info"
                                                      defaultMessage="Customer Information "
                                                      description=""/>
                                </label>
                                </div>
                                <div className="details-section">
                                    <div>
                                        <label className="view-details-body-label">
                                            ユーザー名
                                            :&nbsp; </label>
                                        {this.state.userInfo.userName}
                                    </div>
                                    <div>
                                        <label className="view-details-body-label">
                                            <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                              defaultMessage="Name"
                                                              description=""/>:&nbsp; </label>
                                        {this.state.userInfo.firstName +" "+ this.state.userInfo.lastName}
                                        </div>
                                    <div>
                                        <label className="view-details-body-label">
                                            <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                              defaultMessage="Email"
                                                              description=""/>:&nbsp; </label>
                                        {this.state.userInfo.email}
                                        </div>

                                    <div>
                                        <label className="view-details-body-label">
                                            <FormattedMessage id="app.user-profile.user-profile-info.phone"
                                                              defaultMessage="Phone"
                                                              description=""/>
                                            :&nbsp; </label>
                                        {this.state.contactNumber}
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className=" view-details-header-div">

                                <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.order.single.billing.address"
                                                  defaultMessage="Billing Address "
                                                  description=""/>
                            </label>
                                </div>
                                <div className="details-section">
                                    {/*Postal code*/}
                                    {/*Prefecture*/}
                                    {/*City*/}
                                    {/*District*/}
                                    {/*Village*/}
                                    {/*Street number*/}
                                    {/*Apartment name*/}
                                    {/*room number*/}
                                    <div>{this.state.billOrderInfo.postalCode}</div>
                                    <div>{this.state.billOrderInfo.firstName}&nbsp; {this.state.billOrderInfo.lastName}</div>
                                    <div>{this.state.billOrderInfo.prefecture}</div>
                                    <div>{this.state.billOrderInfo.city}</div>
                                    <div>{this.state.billOrderInfo.street}</div>
                                    <div>{this.state.billOrderInfo.buildingNameAndRoomNo}</div>
                                    <div>{this.state.billContact.number}</div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className=" view-details-header-div">

                                <label className="admin-view-single-order-label">
                                    <FormattedMessage id="app.admin.order.single.shipping.address"
                                                      defaultMessage="Shipping Address "
                                                      description=""/></label>
                                </div>
                                <div className="details-section">
                                    <div>{this.state.shipOrderInfo.postalCode}</div>

                                    <div>{this.state.shipOrderInfo.firstName}&nbsp; {this.state.shipOrderInfo.lastName}</div>
                                    <div>{this.state.shipOrderInfo.prefecture}</div>
                                    <div>{this.state.shipOrderInfo.city}</div>
                                    <div>{this.state.shipOrderInfo.street}</div>
                                    <div>{this.state.shipOrderInfo.buildingNameAndRoomNo}</div>
                                    <div>{this.state.shipContact.number}</div>
                                </div>
                            </div>
                        </div>
                        <br/>
                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-md-6 order-summary-details-responsive">
                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.date"
                                                  defaultMessage="Order Date: "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>
                            <span>

                                {this.state.createdDate.substring(0,4)} 年  {this.state.createdDate.substring(5,7)} 月 {this.state.createdDate.substring(8,10)} 日
                            </span>
                            <br/>

                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.delivery.date"
                                                  defaultMessage="Delivery Date: "
                                                  description=""/>&nbsp;: &nbsp;
                            </label>
                            <span>
                                {/*{this.state.price.deliveryDate}*/}
                                {this.state.orderData.shippedDate && this.state.orderData.shippedDate!==null ?
                                    <text>{this.state.orderData.shippedDate.substring(0,4)}年{this.state.orderData.shippedDate.substring(5,7)}月{this.state.orderData.shippedDate.substring(8,10)}日</text>:
                                    <text>生産中</text>
                                }
                                {/*{this.state.deliveryDate.substring(0,4)} 年  {this.state.deliveryDate.substring(5,7)} 月 {this.state.deliveryDate.substring(8,10)} 日*/}

                            </span>
                            <br/>
                        </div>
                        <div className="col-md-2 empty-div"></div>
                       {/* {this.state.orderItems.map(orderItems => {
                            let orderTotalJson=JSON.parse(orderItems.chargeDetails.priceInfoJson);
                            let total= orderTotalJson.total;
                            orderTotalFromChargeDetails=orderTotalFromChargeDetails+total;


                        })}*/}
                        <div className="col-md-4 pull-right order-total-div">
                            <div className="admin-single-order-total">
                                <FormattedMessage id="app.admin.single.order.bill.total"
                                                  defaultMessage="Bill Total"
                                                  description=""/> : &nbsp;
                                <span>
                                   ¥ <NumberFormatter num={this.state.total}/>
                            </span>
                            </div>
                        </div>
                    </div>
                    <br/>

                    <div className="row">
                        <div className="col-md-12 no-padding">
                            {/*<label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.view.single.order.items"
                                                  defaultMessage="Items"
                                                  description=""/>
                            </label>*/}
                            <hr/>
                                <div className="admin-tables">
                                    <div className="admin-table-row-content">
                                    <CustomerItemTableHeader/>

                                    <ProductionItemTableRow orderInfo={this.state.item} no={1} orderId={this.props.match.params.id} price={this.state.subTotal}/>
                                    </div>
                                </div>


                            {/*<CustomerOrderItemTable orderData={this.props.location.state.items} orderId={this.state.orderId}/>*/}

                        </div>
                    </div>

                    <br/>
                    <div className="row">
                        <div className="pull-right">
                            <Link to={"/admin/production"} className="">
                                <FormattedMessage id="app.admin-info.back"
                                                  defaultMessage="<< Back"
                                                  description=""/>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

}

export default ViewSingleItem;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/ViewSingleItem.js